const FundJump = resolve => {
    import(/* webpackChunkName: 'FundJump' */'../views/fund/Jump').then(FundJump => {
        resolve(FundJump)
    })
}
export default [
    {
        path: '/fund/jump',
        name: 'FundJump',
        component: FundJump,
        meta: {
            title: ''
        }
    }
]
